import React from "react";
import { IconButton } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import ShareIcon from "@mui/icons-material/Share";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import styles from "./styles";

const AssetStatusIcon = ({ data, isLinked }) => {
    const { isAssigned, isExpected, isMandatory, isRelated } = data;
    const classes = makeStyles(styles)();
    // by default all unchecked assets will not show any icon in the search
    let iconStyle = "";
    let IconType = "";

    if (isAssigned) {
        IconType = <CheckOutlinedIcon />;
        iconStyle = classes.searchAssigned;
    } else if (!isRelated) {
        IconType = <ErrorOutlineOutlinedIcon />;
        iconStyle = classes.searchNotRelated;
    } else if (isMandatory && isLinked) {
        IconType = <ShareIcon />;
        iconStyle = classes.searchLinked;
    } else if (isMandatory && !isExpected) {
        IconType = <WarningAmberOutlinedIcon />;
        iconStyle = classes.searchNotExpected;
    } else if (!isMandatory) {
        IconType = <ErrorOutlineOutlinedIcon />;
        iconStyle = classes.searchNotMandatory;
    }

    return (
        <IconButton role="button" className={iconStyle}>
            {IconType}
        </IconButton>
    );
};

export default AssetStatusIcon;

/** Reference
 * isLinked -> The asset is  present the device (Asset found on other audit )
 * isAssigned -> The asset is assigned for audit
 * isRelated -> The asset is  related for the search.
 * isMandatory -> The asset is mandatory to  audit.
 * isExpected -> The asset is expected for the search.
 */
